<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
<div class="title pl-3" v-bind:style="{ 'font-size': $vuetify.breakpoint.lgAndUp? '28px !important': '18px !important', 'font-weight': '400', }">
  <span class="pr-3">COVID-19</span>
  <img src="../../public/assets/awareness.png" v-bind:style="{ 'height': $vuetify.breakpoint.lgAndUp? '55px': '35px', 'vertical-align': 'middle'}" class="pr-3">
  <span class="pr-3">-</span>
  <span>SOUTH AFRICA</span>    
  <span v-if="$vuetify.breakpoint.lgAndUp" style="text-transform: uppercase;" class="ml-3">{{provinceDisplay}}</span>      
  <div v-else style="text-transform: uppercase;" class="ml-3">{{provinceDisplay}}</div>      
</div>
</template>

<script>

  export default {
    name: 'Header',
    props: [ 'provinceDisplay'],
    data: () => ({
    }),
    methods: {
    }
  }
</script>
